import DesktopTableHeader from './DesktopTableHeader';
import DesktopTableBody from './DesktopTableBody';

const DesktopTable = ({
  columns,
  data,
  actions,
  noDataMessage = 'No hay registros disponibles.',
}) => {
  return (
    <div
      className="
        w-full
        overflow-x-auto

        rounded-xl

        border
        border-stroke

        bg-white

        shadow-1

        dark:border-strokedark
        dark:bg-boxdark
      "
    >
      <table className="w-full min-w-[800px] table-auto border-collapse">
        <DesktopTableHeader columns={columns} hasActions={!!actions} />

        <DesktopTableBody
          data={data}
          columns={columns}
          actions={actions}
          noDataMessage={noDataMessage}
        />
      </table>
    </div>
  );
};

export default DesktopTable;
